<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.professions', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-profession' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mProfessions"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="professions-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mProfessions"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data" v-if="can">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-profession', params: { profession: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.professions', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.nom }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteProfession(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="professions-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Professions",

        computed: {
            ...mapGetters(["professions",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },


            mProfessions: function() {
                let pArray = [];

                _.forEach(this.professions, function(profession) {
                    let p = {};

                    p.nom = profession.name;
                    p.date = moment(profession.created_at).format('DD-MM-YYYY HH:mm');
                    p.id = profession.id;
                    p.slug = profession.slug;

                    pArray.push(p);
                });

                return pArray;
            },

            rows: function() {
                return this.mProfessions.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getProfessions() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getProfessions', { args : args });
            },

            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                this.$router.push({ name: 'profession', params: { profession: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'profession', params: { profession: items[0].slug } });
            },

            deleteProfession(profession) {
                let self = this;

                let args = {
                    profession: profession
                };

                let successMessage = this.$i18n.t('message.professionDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteProfession', { args, index: profession, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + profession);
                    });
            }
        },

        mounted() {
            // Fetch profession list
            this.getProfessions();
        }
    }
</script>

<style scoped>

</style>